module.exports = __webpack_public_path__ + "media/site_templates/www.localplasterers.com.au/images/feature_1-828191126c184ba1382776656c8bfec6.jpeg";